import React, {useState,useEffect} from 'react';
import {RouteComponentProps, Redirect, Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MultiLines from './MultiLines';
import {Inc,Item,Owner} from './Inc';
import Ajax from './Ajax';
import PageInput from './PageInput';
import BottomButtons from './BottomButtons';
//import ColData from './ColData';
import RowData from './RowData';
import StoreImg from './StoreImg';
import Loading from './Loading';
import Title from './Title';

interface PageDetailProps {
    owner:Owner,
	managerId:number,
}

interface RCProps extends RouteComponentProps<{id:string}> {
	
}

interface Param {
    photo_ids:number[],
    items:Item[],
}

//let isLoading:boolean = true;
//let pageId = 0;

const PageDetail = (props:PageDetailProps)=> {
    Ajax.setEditorId(props.owner.owner_id);

    const rcp:RCProps = useReactRouter();
    const classes = useStyles();
    const defParam:Param = {
        photo_ids:[],
        items:[],
    }
    const [states,setStates] = useState({
        page: Inc.defaultPage(),
        param: defParam,
        notFound: false,
		isInput: false,
		isLoading: false,
    });
    const load = (pageId:number)=>{
		setStates({...states,isLoading:true});
        Ajax.send("page/get",{page_id:pageId},(res:any)=>{
            //console.log(res);
            if( res.ok ){
				//console.log(Inc.convPage(res.page));
                setStates({page:Inc.convPage(res.page),param:res.param,notFound:false,isInput:false,isLoading:false});
            } else {
                setStates({...states,notFound:true,isLoading:false});
            }
        });
    }
	const openInput = ()=>{
		setStates({...states,isInput:true});
	}
	const closeInput = (updated:boolean,pageId:number)=>{
		if( updated ){
			load(pageId);
		} else {
			setStates({...states,isInput:false});
		}
	}

    useEffect( ()=>{
        if( rcp.match.params.id ){
            const pageId = parseInt(rcp.match.params.id);
            load(pageId);
        }
    },[]);

    if( states.notFound ){
		if( props.owner.owner_id===0 ){
	        return (
    	        <Redirect to="/profile"/>
        	);
		} else {
	        return (
    	        <Redirect to="/"/>
        	);
		}
    }

    //const toEdit = "/page/input/" + String(states.page.page_id);

    return (
		<div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text="シリーズ詳細" icon="cart"/>
                        
                        <div style={{marginBottom:"1em"}}>
                            シリーズは各商品ページの後半に表示されます。プレビューは商品ごとに確認して下さい。<br/>                            
                        </div>

                        <Hidden mdUp implementation="js">
							<BottomButtons button1='編集する' onClick1={openInput} button2='一覧にもどる' link2='/page'/>
                        </Hidden>

                        <Divider style={{marginBottom:"1em"}}/>
                        <Grid container spacing={1}>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>シリーズ名</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.page.page_name}
							</Grid>							
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>シリーズ画像</div>
							</Grid>
							{states.page.img_id>0 ? (
							<Grid item xs={12} sm={9} md={8}>
								<div style={{textAlign:"center"}}>
                                    <StoreImg owner_id={props.owner.owner_id} img_id={states.page.img_id} className="imgItemLarge"/>
                                </div>
							</Grid>
							):(
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								<span className='emptyText'>なし</span>
							</Grid>
							)}
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>シリーズの紹介文</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								<MultiLines text={states.page.page_guide} empty={true}/>
							</Grid>							
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>追加画像</div>
							</Grid>
							{states.param.photo_ids.length>0 ? (
							<Grid item xs={12} sm={9} md={8}>
                                <Grid container spacing={2}>
                                    {states.param.photo_ids.map((img_id:number,index:number)=>{
                                        const key = "img"+index;
                                        return (
                                            <Grid item key={key} xs={6} md={4}>
                                                <StoreImg owner_id={props.owner.owner_id} img_id={img_id} className="imgItemPhoto"/>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
							</Grid>
							):(
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								<span className='emptyText'>なし</span>
							</Grid>
							)}
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>商品の並び</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.param.items.length>0 ? (
								<List style={{margin:'0',padding:'0'}}>
								{states.param.items.map((item:Item,index:number)=>{
									const key = "item"+index;
									const secondary = "ID:"+String(item.item_id);
									return (
										<ListItem key={key}>
											<ListItemIcon><div>{index+1}:</div></ListItemIcon>
											<ListItemText primary={item.item_name} secondary={secondary} classes={{primary:classes.listItemTextSmall,secondary:classes.listItemTextSmall}}/>
										</ListItem>
									)
								})}
								</List>
								):(
								<span className='emptyText'>なし</span>
								)}
							</Grid>							
							<Grid item xs={12}>
								<Divider className="formValidator"/>
							</Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
                        <RowData name="シリーズID" value={String(states.page.page_id)} height={true}/>
                        <RowData name="商品数" value={String(states.page.num_item)} height={true}/>
                        <RowData name="状態" value={states.page.status_label} height={true}/>
                        <Hidden mdDown implementation="js">
                            <Divider style={{margin:"1em 0"}}/>
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={12}>
									<Button variant="contained" color="primary" style={{width:"100%"}} onClick={openInput}>編集する</Button>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Link to="/page"><Button variant="outlined" style={{width:"100%"}}>一覧にもどる</Button></Link>
                                </Grid>
                            </Grid>
                        </Hidden>
                    </Paper>
                </Grid>
            </Grid>
			<PageInput pageId={states.page.page_id} isOpen={states.isInput} owner={props.owner} managerId={props.managerId} close={closeInput}/>
			<Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default PageDetail;
